import script from "./ChatBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatBase.vue?vue&type=script&setup=true&lang=ts"

import "./ChatBase.vue?vue&type=style&index=0&id=47849404&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47849404"]])

export default __exports__